// Generated using MaterialKolor Builder version 1.2.1 (103)
// https://materialkolor.com/?color_seed=FF68A500&dark_mode=false&selected_preset_id=res-0&color_spec=SPEC_2025&package_name=it.maicol07.gamerlogue.theme&misc=true&expressive=true

package it.maicol07.gamerlogue.ui.theme

import androidx.compose.material3.ExperimentalMaterial3ExpressiveApi
import androidx.compose.material3.MotionScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.materialkolor.DynamicMaterialExpressiveTheme
import com.materialkolor.PaletteStyle
import com.materialkolor.dynamiccolor.ColorSpec
import com.materialkolor.rememberDynamicMaterialThemeState
import io.github.kdroidfilter.platformtools.darkmodedetector.isSystemInDarkMode
import it.maicol07.gamerlogue.core.AppPreferences
import it.maicol07.gamerlogue.deviceSeedColor
import org.koin.compose.koinInject

@OptIn(ExperimentalMaterial3ExpressiveApi::class)
@Composable
fun AppTheme(content: @Composable () -> Unit) {
    val preferences = koinInject<AppPreferences>()
    val theme by preferences.theme.collectAsState()
    val useDynamicColors by preferences.useDynamicColors.collectAsState()

    val deviceSeedColor = deviceSeedColor()
    val dynamicThemeState = rememberDynamicMaterialThemeState(
        isDark = theme.isDark ?: isSystemInDarkMode(),
        style = PaletteStyle.TonalSpot,
        specVersion = ColorSpec.SpecVersion.SPEC_2025,
        seedColor = deviceSeedColor.takeIf { useDynamicColors } ?: SeedColor,
    )

    DynamicMaterialExpressiveTheme(
        state = dynamicThemeState,
        motionScheme = MotionScheme.expressive(),
        animate = true,
        content = content,
    )
}
